import CryptoJS from "crypto-js";

const ENCRYPTION_KEY = process.env.NEXT_PUBLIC_ENCRYPTION_KEY as string; // Use a secure server-side key
const BANCKEND_ENCRYPTION_KEY = process.env.NEST_PUBLIC_ENCRYPTION_KEY as string; // Use a secure server-side key

if (!ENCRYPTION_KEY) {
  throw new Error("No encryption key found");
}

export function encrypt(payload: any): any {
  const stringPayload = typeof payload === "string" ? payload : JSON.stringify(payload);
  return CryptoJS.AES.encrypt(stringPayload, ENCRYPTION_KEY).toString();
}

export function decrypt(payload: any): any {
  const bytes = CryptoJS.AES.decrypt(payload, ENCRYPTION_KEY);
  const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
  
  if (!decryptedText) {
    throw new Error("Decryption failed. Invalid key or data.");
  }
  
  return decryptedText;
}

  export function banckendEncrypt(payload: any): any {
    const stringPayload = typeof payload === "string" ? payload : JSON.stringify(payload);
    return CryptoJS.AES.encrypt(stringPayload, BANCKEND_ENCRYPTION_KEY).toString();
  }

  export function backendDecrypt(payload: any): any {
    const bytes = CryptoJS.AES.decrypt(payload, BANCKEND_ENCRYPTION_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    
    if (!decryptedText) {
      throw new Error("Decryption failed. Invalid key or data.");
    }
    return decryptedText;
  }
export const hashCard = (cardNumber: string): string => {
  try {
    const encryptionKey = process.env.NEXT_PUBLIC_FIREBASE_ENCRYPTION_KEY || "";
    const hash = CryptoJS.HmacSHA256(cardNumber, encryptionKey).toString(CryptoJS.enc.Hex);
    return hash;
  } catch (error) {
    throw new Error("Decryption failed. Invalid key or data.");
  }
}
